import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'telxl-shared-loading-panel',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './loading-panel.component.html',
    styleUrl: './loading-panel.component.scss',
})
export class TelXLLoadingPanelComponent {}
